var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#website_svg_01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8901 6.75C12.3347 3.26172 11.0246 0.8125 9.5 0.8125C7.9754 0.8125 6.66532 3.26172 6.10988 6.75H12.8901ZM5.82258 10.5C5.82258 11.3672 5.86855 12.1992 5.94899 13H13.0472C13.1276 12.1992 13.1736 11.3672 13.1736 10.5C13.1736 9.63281 13.1276 8.80078 13.0472 8H5.94899C5.86855 8.80078 5.82258 9.63281 5.82258 10.5ZM18.2607 6.75C17.1651 4.09766 14.9472 2.04688 12.2083 1.21875C13.1429 2.53906 13.7865 4.52734 14.1236 6.75H18.2607ZM6.7879 1.21875C4.05282 2.04688 1.83105 4.09766 0.739314 6.75H4.87641C5.20968 4.52734 5.85323 2.53906 6.7879 1.21875ZM18.6706 8H14.2768C14.3573 8.82031 14.4032 9.66016 14.4032 10.5C14.4032 11.3398 14.3573 12.1797 14.2768 13H18.6667C18.8774 12.1992 18.9962 11.3672 18.9962 10.5C18.9962 9.63281 18.8774 8.80078 18.6706 8ZM4.59677 10.5C4.59677 9.66016 4.64274 8.82031 4.72319 8H0.329435C0.122581 8.80078 0 9.63281 0 10.5C0 11.3672 0.122581 12.1992 0.329435 13H4.71935C4.64274 12.1797 4.59677 11.3398 4.59677 10.5ZM6.10988 14.25C6.66532 17.7383 7.9754 20.1875 9.5 20.1875C11.0246 20.1875 12.3347 17.7383 12.8901 14.25H6.10988ZM12.2121 19.7812C14.9472 18.9531 17.169 16.9023 18.2645 14.25H14.1274C13.7903 16.4727 13.1468 18.4609 12.2121 19.7812ZM0.739314 14.25C1.83488 16.9023 4.05282 18.9531 6.79173 19.7812C5.85706 18.4609 5.21351 16.4727 4.87641 14.25H0.739314Z",
    fill: "#0A0909"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "website_svg_01"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.1f6d46ed.svg";
export { ForwardRef as ReactComponent };